module.exports = __webpack_public_path__ + "img/football-vertical.e73ac4ed.png";